function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.001)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.658,55.5a34,34,0,1,1,52.789-.128L33.995,94.032Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 34.00187301635742 79.86492919921875 L 54.22674179077148 50.33849334716797 C 58.00363922119141 45.67023086547852 60 40.02047348022461 60 33.99999237060547 C 60 19.66355133056641 48.33644104003906 8.000012397766113 34 8.000012397766113 C 19.66356086730957 8.000012397766113 8 19.66355133056641 8 33.99999237060547 C 8 40.06595230102539 10.02390003204346 45.74959182739258 14.26228046417236 50.98369216918945 L 34.00187301635742 79.86492919921875 M 33.9946403503418 94.03195190429688 L 7.657559871673584 55.49785232543945 C 2.871599912643433 49.63963317871094 0 42.15447235107422 0 33.99999237060547 C 0 15.22237205505371 15.22237968444824 1.21374514492345e-05 34 1.21374514492345e-05 C 52.77761840820313 1.21374514492345e-05 68 15.22237205505371 68 33.99999237060547 C 68 42.09601211547852 65.17047882080078 49.53099060058594 60.44612121582031 55.37033081054688 L 33.9946403503418 94.03195190429688 Z",
  stroke: "none",
  fill: "#313131"
})));

var SvgDropOutlined = function SvgDropOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 94.032,
    viewBox: "0 0 68 94.032",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drop-outlined.240dc9c3.svg";
export { ForwardRef as ReactComponent };